import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { isCronJobsTestingEnabled } from '@zenos/front-end-util-utils';
import { Roles } from '@zenos/shared-utils';
import { ability } from '../ability';

export function updateZenOSAbility<
  T extends { role?: string | undefined } | undefined,
>(props: T) {
  const abilityBuilder = new AbilityBuilder(createMongoAbility);

  if (props?.role === Roles.ADMINISTRATOR || props?.role === Roles.SUPERADMIN) {
    abilityBuilder.can('see', 'TimesheetAdminSelect');
    abilityBuilder.can('see', 'Admin');
    abilityBuilder.can('see', 'Slack Exceptions');
  }

  if (props?.role === Roles.SUPERADMIN && isCronJobsTestingEnabled()) {
    abilityBuilder.can('see', 'Notifications');
  }

  if (
    props?.role === Roles.ADMINISTRATOR ||
    props?.role === Roles.SUPERADMIN ||
    props?.role === Roles.PROJECT_MANAGER ||
    props?.role === Roles.DELIVERY_MANAGER ||
    props?.role === Roles.CSM ||
    props?.role === Roles.PROJECT_COORDINATOR ||
    props?.role === Roles.DELIVERY_LEAD
  ) {
    abilityBuilder.can('see', 'Approval');
    abilityBuilder.can('see', 'Projects');
    abilityBuilder.can('see', 'Reports');
    abilityBuilder.can('see', 'Logs');
    abilityBuilder.can('see', 'Logged vs Allocated');
    abilityBuilder.can('see', 'Missing Approvals');
    abilityBuilder.can('see', 'Missing Submissions');
    abilityBuilder.can('see', 'Timesheet by Employee');

    if (
      props?.role === Roles.ADMINISTRATOR ||
      props?.role === Roles.SUPERADMIN
    ) {
      abilityBuilder.can('see', 'Bench');
    }
  }

  ability.update(abilityBuilder.rules);
}
